import { render } from "./NewSystemUser.vue?vue&type=template&id=2e90789c&scoped=true"
import script from "./NewSystemUser.vue?vue&type=script&lang=js"
export * from "./NewSystemUser.vue?vue&type=script&lang=js"

import "./NewSystemUser.vue?vue&type=style&index=0&id=2e90789c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e90789c"]])

export default __exports__